import styled from 'styled-components';
import Button from '~/components/Button';
import Text from '~/components/Text';

export const StyledButton = styled(Button)`
	margin-top: 4px;
	padding: 4px 3px;
`;

export const StyledButtonText = styled(Text)`
	font-weight: 400;
	font-size: 1.4rem;
`;
